import React from "react";
import tw from "twin.macro";
import { StyledContainer } from "../../Styled/Container";
import { type SellingPointsOutputProps } from "./withSellingPoints";

const Container = tw(StyledContainer)`
  pb-mega md:pb-giga
`;
const Point = tw.div`
  flex flex-wrap pb-midi md:pb-maxi items-center
`;
const Title = tw.h3`
  block w-full md:w-1/3 font-display text-h4 leading-caption md:text-[32px] md:leading-body
`;
const Description = tw.p`
  block w-full md:w-2/3 md:pl-maxi text-body leading-body
`;

const SellingPointsList = ({
  points,
  width,
}: Partial<SellingPointsOutputProps>) => {
  if (!points?.length) {
    return;
  }

  return (
    <Container width={width} data-testid="selling-points-list">
      {points.map(({ title, description }) => (
        <Point key={title}>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </Point>
      ))}
    </Container>
  );
};

export default SellingPointsList;
